import React from 'react';
import { useSelector } from 'react-redux';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { IRootState } from 'src/reducers';
import useDebounce from 'src/util/hooks/use-debounce';
import { Url } from 'src/api';
import useFetch from 'use-http';
import LoadingPanel from 'src/components/common/LoadingPanel.redesign';
import SearchResultCard from './SearchResultCard';
import CardContainer from 'src/components/common/CardContainer.redesign';
import SearchResult from 'src/models/OwnerSearchResult';

interface IOwnerSearchProps {
    clientNumber?: number;
    projectNumber?: number;
    ownerSearchResult: (values: { selectedOwner: SearchResult; isLoading: boolean; error: string }) => void;
}

const noop = (): void => {
    return null;
};

const OwnerSearch: React.FC<IOwnerSearchProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();

    const [resourceNumber, setResourceNumber] = React.useState({ clientNumber: props.clientNumber, projectNumber: props.projectNumber });
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const [loading, setLoading] = React.useState(false);
    const [owners, setOwners] = React.useState([]);
    const [selectedOwner, setSelectedOwner] = React.useState(undefined);

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    React.useEffect(() => {
        setResourceNumber({
            clientNumber: resourceNumber.clientNumber || appContext.clientNumber,
            projectNumber: resourceNumber.projectNumber || appContext.projectNumber,
        });
    }, [appContext]);

    React.useEffect(() => {
        if (debouncedSearchTerm && debouncedSearchTerm.length >= 3) {
            searchUsers();
        }
    }, [debouncedSearchTerm]);

    React.useEffect(() => {
        props.ownerSearchResult({ selectedOwner, isLoading: loading, error: '' });
    }, [selectedOwner, loading]);

    const searchUsers = async () => {
        setLoading(true);
        setSelectedOwner(undefined);

        const qs = new URLSearchParams({
            searchTerm: debouncedSearchTerm.toString(),
            ownerType: 'All',
        });

        const result = await get(`${Url.project.getProject(appContext, appContext.projectNumber)}/owners?${qs.toString()}`);

        if (response.ok) {
            props.ownerSearchResult({ selectedOwner: undefined, isLoading: false, error: undefined });
            setLoading(false);
            setOwners(result);
        }
    };

    const searchTermChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    const updateSelectedOwner = (owner: SearchResult) => {
        if (owner.id === selectedOwner?.id) {
            setSelectedOwner(undefined);
        } else {
            setSelectedOwner(owner);
        }
    };

    const ownerPanel = () => {
        if (debouncedSearchTerm) {
            if (debouncedSearchTerm.length < 3) {
                return <div>Enter at least 3 characters to search.</div>;
            }

            if (owners && owners.length > 0) {
                return (
                    <div style={{maxHeight: '70vh', overflowY: 'auto'}}>
                        <CardContainer>
                            {owners.map((o: SearchResult) => (
                                <SearchResultCard key={o.id} item={o} isSelected={o.id === selectedOwner?.id} onSelected={updateSelectedOwner}>
                                    <span style={{ display: 'inline-block', width: '15%' }}>{o.id}</span>
                                    <span style={{ display: 'inline-block', width: '78%' }}>
                                        {o.name} - [{o.type}]
                                    </span>
                                </SearchResultCard>
                            ))}
                        </CardContainer>
                    </div>
                );
            }

            return <div>No Owners matched search</div>;
        }

        return <div>Enter Search Term above</div>;
    };

    return (
        <div>
            <Form onSubmit={noop}>
                <FormTextBox name="searchText" label="Search For Existing Owners" onChange={searchTermChange} />
            </Form>
            <div>
                <LoadingPanel isLoading={loading}>{ownerPanel()}</LoadingPanel>
            </div>
        </div>
    );
};

// const OwnerSearchCard = () => {
//     return <div> OwnerCard</div>;
// };

export default OwnerSearch;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/OwnerSearch.tsx